export const downloadJSON = (data: any, filename: string) => {
  const jsonStr = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonStr], {type: 'application/json'});
  downloadFile(blob, filename, 'application/json');
};

export const downloadFile = (data: BlobPart, filename: string, type: string) => {
  const blob = new Blob([data], {type});
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
};
